import { Link } from '@material-ui/core';
import { Edit, FileCopy } from '@material-ui/icons';
import * as i18next from 'i18next';
import React from 'react';

import { CellRenderer, MainColumns } from '../../../components/TableGrid';
import { formatUtcToLocalString } from '../../../core/utils/date.utils';
import { BenchmarkView } from '../../../generated/model/benchmarkView';

export const getBenchmarkListTableColumns = (
  t: i18next.TFunction,
  onOpenEditModal: (benchmarkRow: BenchmarkView) => void,
  onOpenCloneModal: (benchmarkRow: BenchmarkView) => void,
) => {
  return [
    {
      headerName: '',
      field: 'navigateToIcon',
      width: 45,
      maxWidth: 45,
      cellRenderer: CellRenderer.BenchmarkLinkCellRenderer,
      cellRendererParams: {
        toolTipText: 'Load benchmark',
      },
    },
    {
      headerName: '',
      field: 'cloneIcon',
      width: 40,
      maxWidth: 40,
      cellRenderer: CellRenderer.Clickable,
      cellRendererParams: {
        icon: (
          <Link>
            <FileCopy />
          </Link>
        ),
        onClickHandler: onOpenCloneModal,
        toolTipText: 'Clone benchmark',
      },
    },
    {
      headerName: '',
      field: 'editIcon',
      width: 40,
      maxWidth: 40,
      cellRenderer: CellRenderer.Clickable,
      cellRendererParams: {
        icon: (
          <Link>
            <Edit />
          </Link>
        ),
        onClickHandler: onOpenEditModal,
        toolTipText: 'Edit benchmark',
      },
    },
    {
      headerName: `${t('benchmark:columns:name')}`,
      field: 'name',
      cellRenderer: CellRenderer.NumberOrText,
      sortable: true,
      comparator: nameComparator,
      // https://www.ag-grid.com/javascript-grid-filter-text/
      floatingFilter: true,
      filter: 'agTextColumnFilter',
      filterParams: { suppressAndOrCondition: true },
      floatingFilterComponentParams: { suppressFilterButton: true },
    },
    {
      headerName: `${t('benchmark:columns:status')}`,
      valueGetter: (params) =>
        params.data?.refinementSearchId
          ? t('benchmark:resolveBenchmarkCompany.refinementInProgress')
          : '',
    },
    {
      headerName: `${t('benchmark:columns:currency')}`,
      field: 'currency',
      floatingFilter: true,
      filter: 'agTextColumnFilter',
      filterParams: { suppressAndOrCondition: true },
      floatingFilterComponentParams: { suppressFilterButton: true },
    },
    {
      headerName: `${t('benchmark:columns:creationTime')}`,
      field: 'createdAt',
      cellRenderer: (params: any) => formatUtcToLocalString(params.value),
      sortable: true,
    },
    {
      headerName: `${t('benchmark:columns:createdBy')}`,
      field: 'username',
      sortable: true,
      floatingFilter: true,
      filter: 'agTextColumnFilter',
      filterParams: { suppressAndOrCondition: true },
      floatingFilterComponentParams: { suppressFilterButton: true },
    },
    {
      headerName: t('benchmark:columns:shared'),
      field: 'shared',
      cellRenderer: (params: any) =>
        params.value === true
          ? t('benchmark:columns:sharedValue.shared')
          : t('benchmark:columns:sharedValue.private'),
      sortable: true,
      width: 100,
      maxWidth: 120,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: { suppressAndOrCondition: true },
      floatingFilterComponentParams: { suppressFilterButton: true },
    },
    {
      headerName: `${t('benchmark:columns:modifyTime')}`,
      field: 'lastModifiedAt',
      cellRenderer: (params: any) => formatUtcToLocalString(params.value),
      sortable: true,
    },
  ] as MainColumns[];
};

const nameComparator = (value1: string, value2: string) => {
  if (value1 == null && value2 == null) {
    return 0;
  }
  if (value1 == null) {
    return -1;
  }
  if (value2 == null) {
    return 1;
  }

  return value1.localeCompare(value2, undefined, { sensitivity: 'base' });
};
